import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/subjects/searchbar";
import SubjectsTable from "../../../containers/admin/subjects/table";
import { getAllSubjectsRequest } from "../../../modules/admin-modules/subjects/Actions";

const Subjects = () => {
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.subjects.subjects);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllSubjectsRequest());
  }, [dispatch]);

  const filteredCount = useMemo(() => {
    if (!subjects?.length) return 0;
    return subjects.filter((subject) =>
      subject.name?.toLowerCase().includes(searchTerm.toLowerCase())
    ).length;
  }, [subjects, searchTerm]);

  return (
    <Layout>
      <SearchBar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        count={filteredCount}
      />
      <SubjectsTable searchTerm={searchTerm} />
    </Layout>
  );
};

export default Subjects;
